import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import { GetInvoiceScanResponseT } from '../types/invoice_scans.types'
import { PretensionByNumResponseT } from '@/core/types/pretensions.types'

export class InvoiceScansRepository {
    getScan(invoice_number: string): Promise<AxiosResponse<GetInvoiceScanResponseT>> {
        return http.get(`/cabinet/api/v2/logistics-info/cargo-photo/${invoice_number}/get-url`)
    }

    saveScan(invoice_number: string, file: File, fileType: number): Promise<AxiosResponse<void>> {
        const payload = new FormData()

        payload.append('invoice_number', invoice_number)
        payload.append('file', file)
        payload.append('fileType', fileType.toString())

        return http.postFormData(`/cabinet/api/v2/logistics-info/save-invoice-scan`, payload)
    }

    getInfoByNum(invoiceNumber: string): Promise<AxiosResponse<PretensionByNumResponseT>> {
        return http.get(`/cabinet/api/v2/logistics-info/invoice-number/${invoiceNumber}`)
    }
}
